import { t } from '@/locales/i18n'

export const genericPayouts = [
  {
    id: '1000pTT',
    name: t('payouts_dialog.players1000.mtt'),
    blocks: [
      {
        rows: [
          ['1.', '15.19%', '$30,380'],
          ['2.', '10.96%', '$21,920'],
          ['3.', '7.94%', '$15,880'],
          ['4.', '5.76%', '$11,520'],
          ['5.', '4.17%', '$8,340'],
          ['6.', '3.06%', '$6,120'],
          ['7.', '2.24%', '$4,480'],
          ['8.', '1.64%', '$3,280'],
          ['9.', '1.39%', '$2,780'],
          ['10.', '1.02%', '$2,040'],
          ['11.', '0.95%', '$1,900'],
          ['12-13.', '0.82%', '$1,640'],
          ['14.', '0.77%', '$1,540'],
          ['15-17.', '0.70%', '$1,400'],
          ['18-21.', '0.60%', '$1,200'],
          ['22-23.', '0.55%', '$1,100'],
          ['24-25.', '0.51%', '$1,020'],
          ['26-33.', '0.46%', '$920'],
          ['34-35.', '0.44%', '$880'],
          ['36-41.', '0.41%', '$820'],
          ['42-53.', '0.38%', '$760'],
          ['54-57.', '0.35%', '$700'],
          ['58-73.', '0.33%', '$660'],
          ['74-77.', '0.31%', '$620'],
          ['78-89.', '0.29%', '$580'],
          ['90-101.', '0.27%', '$540'],
          ['102-116.', '0.23%', '$460'],
          ['117-125.', '0.22%', '$440'],
          ['126-150.', '0.20%', '$400'],
        ],
      },
    ],
  },
  {
    id: '200pMTT',
    name: t('payouts_dialog.players200.mtt'),
    blocks: [
      {
        rows: [
          ['1.', '19.14%', '$7,656'],
          ['2.', '14.17%', '$5,668'],
          ['3.', '10.49%', '$4,196'],
          ['4.', '8.01%', '$3,204'],
          ['5.', '6.14%', '$2,456'],
          ['6.', '4.81%', '$1,924'],
          ['7.', '3.71%', '$1,484'],
          ['8.', '2.85%', '$1,140'],
          ['9.', '2.22%', '$888'],
          ['10-11.', '1.87%', '$748'],
          ['12-13.', '1.69%', '$676'],
          ['14-17.', '1.49%', '$596'],
          ['18-23.', '1.28%', '$512'],
          ['24-30.', '1.10%', '$440'],
        ],
      },
    ],
  },
  {
    id: '200pPKo',
    name: t('payouts_dialog.players200.pko'),
    blocks: [
      {
        rows: [
          ['1-2.', '16.13%', '$3,226'],
          ['3.', '11.12%', '$2,224'],
          ['4.', '8.38%', '$1,676'],
          ['5.', '6.32%', '$1,264'],
          ['6.', '4.76%', '$952'],
          ['7.', '3.59%', '$718'],
          ['8.', '2.71%', '$542'],
          ['9.', '2.21%', '$442'],
          ['10-11.', '1.80%', '$360'],
          ['12-13.', '1.63%', '$326'],
          ['14-17.', '1.46%', '$292'],
          ['18-23.', '1.33%', '$266'],
          ['24-30.', '1.14%', '$228'],
        ],
      },
    ],
  },
  {
    id: '1000pPKo',
    name: t('payouts_dialog.players1000.pko'),
    blocks: [
      {
        rows: [
          ['1.', '11.280%', '$11,280'],
          ['2.', '11.275%', '$11,275'],
          ['3.', '7.615%', '$7,615'],
          ['4.', '5.700%', '$5,700'],
          ['5.', '4.325%', '$4,325'],
          ['6.', '3.260%', '$3,260'],
          ['7.', '2.475%', '$2,475'],
          ['8.', '1.915%', '$1,915'],
          ['9.', '1.455%', '$1,455'],
          ['10-11.', '1.090%', '$1,090'],
          ['12-13.', '1.005%', '$1,005'],
          ['14-17.', '0.810%', '$810'],
          ['18-21.', '0.635%', '$635'],
          ['22-25.', '0.580%', '$580'],
          ['26.', '0.525%', '$525'],
          ['27-33.', '0.485%', '$485'],
          ['34-41.', '0.445%', '$445'],
          ['42-44.', '0.410%', '$410'],
          ['45-57.', '0.385%', '$385'],
          ['58-71.', '0.350%', '$350'],
          ['72-73.', '0.330%', '$330'],
          ['74-89.', '0.305%', '$305'],
          ['90-98.', '0.275%', '$275'],
          ['99-121.', '0.260%', '$260'],
          ['122-150.', '0.200%', '$200'],
        ],
      },
    ],
  },
]
